
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Paragraph, Anatomy, Link } from '@ecl/website-components';

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Paragraph size="lead" mdxType="Paragraph">
  The radio button component is an input{' '}
  <strong>with at least two, mutually exclusive options</strong>, where{' '}
  <strong>just one selection</strong> can be made at any time so that an option
  is selected, the other options are deselected.
    </Paragraph>
    <h2>{`Anatomy`}</h2>
    <Anatomy image="https://inno-ecl.s3.amazonaws.com/media/images/EC/Radio/Radio%20buttons2.jpg" alt="Anatomy of radio button" legend={{
      items: [{
        color: '#404040',
        label: 'Mandatory'
      }, {
        color: '#004494',
        label: 'Optional'
      }]
    }} mdxType="Anatomy" />
    <h3>{`Default`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Elements`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Mandatory`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Heading`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The `}<strong parentName="td">{`heading of the group`}</strong>{` of related radio buttons`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Group Helper Text`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`No`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Helper information to describe the radio button group`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Radio button`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The `}<strong parentName="td">{`actionable part`}</strong>{` of the component - either selected or un-selected`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Radio Button Label`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The label of the radio button`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Helper Text`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`No`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Helper information to assist the user in selecting the appropriate radio buttons`}</td>
        </tr>
      </tbody>
    </table>
    <h3>{`Conditional`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Elements`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Mandatory`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Optional Indicator`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Indicator stating `}<strong parentName="td">{`if`}</strong>{` input fields are `}<strong parentName="td">{`optional`}</strong>{`. `}<strong parentName="td">{`All fields are mandatory by default - only ask for information that is required`}</strong></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Error Message`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A message informing the user `}<strong parentName="td">{`if`}</strong>{` there is a problem with their entry`}</td>
        </tr>
      </tbody>
    </table>
    <h2>{`Do's`}</h2>
    <ul>
      <li parentName="ul">{`aim for `}<strong parentName="li">{`distinct headings`}</strong>{` within the same group in order to improve scannability and reduce possible confusion`}</li>
      <li parentName="ul"><strong parentName="li">{`use labels as click targets`}</strong>{` (clicking the label will select that option)`}</li>
      <li parentName="ul"><strong parentName="li">{`arrange them vertically`}</strong>{` to improve scannability and reduce errors`}</li>
      <li parentName="ul"><strong parentName="li">{`group`}</strong>{` related fields`}</li>
      <li parentName="ul"><strong parentName="li">{`order`}</strong>{` logically (e.g. ages 18-25, ages 25-35, ages, 35-50, over 65)`}</li>
      <li parentName="ul">{`indicate whether the input group is `}<strong parentName="li">{`optional`}</strong>{` - `}<strong parentName="li">{`if it's mandatory, have a neutral option (e.g. other, n/a) selected by default`}</strong></li>
      <li parentName="ul"><strong parentName="li">{`make use of helper text`}</strong>{` if there are further directions or hints the users may need in completing their goal`}</li>
      <li parentName="ul"><strong parentName="li">{`write specific and clear error messages`}</strong>{`, so users understand how to address the error`}</li>
    </ul>
    <h2>{`Don'ts`}</h2>
    <ul>
      <li parentName="ul"><strong parentName="li">{`don't add them without grouping first`}</strong>{`, in a logical order of successive tasks`}</li>
      <li parentName="ul"><strong parentName="li">{`don't nest elements`}</strong>{` under radio buttons - keep all the options on the same level`}</li>
    </ul>
    <h2>{`When to use`}</h2>
    <ul>
      <li parentName="ul"><strong parentName="li">{`when you have under 10 items`}</strong></li>
      <li parentName="ul"><strong parentName="li">{`when only one selection is needed`}</strong>{` from a list`}</li>
      <li parentName="ul">{`when users need to `}<strong parentName="li">{`select options`}</strong>{` or `}<strong parentName="li">{`toggle settings`}</strong>{`, for example`}</li>
      <li parentName="ul"><strong parentName="li">{`in forms`}</strong>{` with multiple non-exclusive options (e.g. search filters)`}</li>
    </ul>
    <h2>{`When not to use`}</h2>
    <ul>
      <li parentName="ul">{`avoid when more than one option can be selected`}</li>
    </ul>
    <h2>{`Related components`}</h2>
    <ul>
      <li parentName="ul"><Link to="/ec/components/forms/select/usage/" mdxType="Link">Select</Link></li>
      <li parentName="ul"><Link to="/ec/components/forms/text-area/usage/" mdxType="Link">Text area</Link></li>
      <li parentName="ul"><Link to="/ec/components/forms/text-field/usage/" mdxType="Link">Text field</Link></li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;